export default {
	ifOnboarding: false,
	obAllowedOptions: [],

	launcherState: 'INIT',
	open: false,
	loggedIn: false,
	userIdentifier: '',
	status: '',
	list: [],
	storeInputText: '',
	autoCompleteText: '',
	crumbs: [],
	activeIdx: 0,
	displayListLength: 0,
	curURL: '',
	allyPlaceholder: 'What do you want to do?',
	gk: {},
	dataPanelSide: '',
	rows: [],
	user: {},
	columns: [],
	totalRows: 0,
	splitData: false,
	loading: false,
	previewState: {},
	serverURL:
		window.location.href.indexOf('localhost') >= 0
			? 'http://localhost:8080'
			: 'https://server.include.ai',
	hqURL:
		window.location.href.indexOf('localhost') >= 0
			? 'http://localhost:8081'
			: 'https://hq.include.ai',
};
